import script from "./dispatchCar.vue?vue&type=script&setup=true&lang=js"
export * from "./dispatchCar.vue?vue&type=script&setup=true&lang=js"

import "./dispatchCar.vue?vue&type=style&index=0&id=3d68ef34&lang=scss"

const __exports__ = script;

export default __exports__